import { FilterGroupComponents } from '@/app/common/filters/surfaces/forms/FilterGroupComponents.tsx';
import type {
  CustomFilterGroupLabelCreator,
  CustomFilterLabelCreator,
  CustomFilterMainCreator,
  CustomGroupCreator,
  HandleFilterChanged,
} from '@/app/common/filters/core/filterComponentType.ts';
import type { FiltersGroups } from '@/app/common/filters/core/filtersTypes.ts';
import { Column } from '@/app/common/components/Base/List.tsx';
import { useFiltersUiData } from '@/app/common/filters/surfaces/provider/filtersUiProvider.tsx';
import { useIsModalViewport } from '@/app/components/search/utils/useSsrMedia.ts';

export type CustomGroupCreators = { [customGroupName: string]: CustomGroupCreator };
export type CustomFilterMainCreators = { [key: string]: CustomFilterMainCreator };
export type CustomFilterLabelCreators = { [key: string]: CustomFilterLabelCreator };
export type CustomFilterGroupLabelCreators = { [key: string]: CustomFilterGroupLabelCreator };

type FilterGroupsComponentsProps = {
  filtersGroups: FiltersGroups;
  customGroupCreators?: CustomGroupCreators;
  customFilterMainCreators?: CustomFilterMainCreators;
  isLoading: boolean;
  handleFilterChanged: HandleFilterChanged;
};

export const FilterGroupsComponents = ({
  filtersGroups,
  customGroupCreators,
  customFilterMainCreators,
  isLoading,
  handleFilterChanged,
}: FilterGroupsComponentsProps) => {
  const { isMobile } = useFiltersUiData();
  const isModalViewport = useIsModalViewport(isMobile);
  const filterGroupsComponents = filtersGroups.map((filtersGroup) => {
    if ('label' in filtersGroup) {
      return (
        <FilterGroupComponents
          key={filtersGroup?.label}
          filtersGroup={filtersGroup}
          customGroupCreators={customGroupCreators}
          customFilterMainCreators={customFilterMainCreators}
          isLoading={isLoading}
          handleFilterChanged={handleFilterChanged}
          isModalViewport={isModalViewport}
        />
      );
    }

    if ('customGroupName' in filtersGroup) {
      return (
        <FilterGroupComponents
          key={filtersGroup.id}
          filtersGroup={filtersGroup}
          customGroupCreators={customGroupCreators}
          customFilterMainCreators={customFilterMainCreators}
          isLoading={isLoading}
          handleFilterChanged={handleFilterChanged}
          isModalViewport={isModalViewport}
        />
      );
    }

    return null;
  });

  return (
    <Column gap={16} columns={1}>
      {filterGroupsComponents}
    </Column>
  );
};
